import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton } from '@mui/material';
import { FC } from 'react';

export interface FilterButtonProps {
  onClick: () => void;
}

export const FilterButton: FC<FilterButtonProps> = (props) => {
  const { onClick } = props;

  return (
    <IconButton onClick={onClick} sx={{ width: '32px', height: '32px', border: 'solid 1px #0675DD' }}>
      <FilterListIcon sx={{ color: '#0675DD' }} />
    </IconButton>
  );
};
